<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>GitHub</h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item active">GitHub</li>
        </ol>
      </div>
    </div>
  </div>
</section>

<section class="content">
  <div class="container-fluid">
	<div class="col-lg-12 deploymentInfos" style="height:auto;margin: 0 0 10px 0;">
		<mat-card style="height:100%">
			<button
			  mat-raised-button
			  color="primary"
			  [class.spinner]="loadingDeploymentInfosLoad"
			  (click)="getDeploymentsInfos()"
			>
				Deployments Infos
			</button>
			<div style="margin: 0; width: 90%" *ngIf="isDeploymentInfosShownLoad">
				<ng-container *ngIf="isDeploymentInfosShownLoad">
					<mat-grid-list cols="1" rowHeight="170px">
						<mat-grid-tile *ngFor="let deploymentsInfo of deploymentsInfos" class="deploymentInfosRepo">
							<mat-card>
								<mat-card-title>{{ deploymentsInfo.repository_name }}</mat-card-title>
								<mat-card-content>
									<mat-grid-list cols="7" rowHeight="25px">
										<mat-card-subtitle>
											<mat-grid-tile>Last tag :</mat-grid-tile>
										</mat-card-subtitle>
										<mat-grid-tile>
											{{ deploymentsInfo.lastTag?.tag || null }}
										</mat-grid-tile>
										<mat-grid-tile>
											{{ deploymentsInfo.lastTag?.date | date: 'yyyy-MM-dd HH:mm:ss' || null }}
										</mat-grid-tile>
										<mat-grid-tile>
											{{ deploymentsInfo.lastTag?.tagger || null }}
										</mat-grid-tile>
										<mat-grid-tile>
											<a mat-raised-button [href]="deploymentsInfo.lastTag?.url" target="_blank" >Link</a>
										</mat-grid-tile>
										<mat-grid-tile>
											<a
												mat-raised-button
												[href]="deploymentsInfo.lastTag?.commits"
												target="_blank"
												>Commits</a
											>
										</mat-grid-tile>
										<mat-grid-tile>
											<a
												mat-raised-button
												[href]="deploymentsInfo.lastTag?.lastCommit"
												target="_blank"
												>Last commit</a
											>
										</mat-grid-tile>
									</mat-grid-list>
								</mat-card-content>
								<mat-card-content>	
									<mat-card-subtitle>
										Deployments :
									</mat-card-subtitle>
								</mat-card-content>
								<mat-card-content>
									<div *ngFor="let deployment of deploymentsInfo.deployments">
										<mat-grid-list cols="7" rowHeight="25px">
											<mat-grid-tile>
												{{ deployment?.environment || null }}
											</mat-grid-tile>
											<mat-grid-tile>
												{{ deployment?.tag || null }}
											</mat-grid-tile>
											<mat-grid-tile>
												{{ deployment?.date | date: 'yyyy-MM-dd HH:mm:ss' || null }}
											</mat-grid-tile>
											<mat-grid-tile>
												{{ deployment?.creator || null }}
											</mat-grid-tile>
											<mat-grid-tile>
												{{ deployment?.status || null }}
											</mat-grid-tile>
											<mat-grid-tile>
												<a
													mat-raised-button
													[href]="deployment?.url"
													target="_blank"
													>Link</a
												>
											</mat-grid-tile>
											<mat-grid-tile>
												<a
													mat-raised-button
													[href]="deployment?.actionUrl"
													target="_blank"
													>Actions</a
												>
											</mat-grid-tile>
										</mat-grid-list>
									</div>
								</mat-card-content>
							</mat-card>
						</mat-grid-tile>
					</mat-grid-list>
				</ng-container>
			</div>	
		</mat-card>
	</div>

    <div class="col-lg-12 githubForm">
      <mat-card>
        <form [formGroup]="githubForm">
          <mat-form-field appearance="fill">
            <mat-label>Base branch</mat-label>
            <input
              type="text"
              matInput
              formControlName="baseBranchName"
              placeholder="Ex. release/bcitiPlus-1.24.0"
              required
            />
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Head branch</mat-label>
            <input
              type="text"
              matInput
              formControlName="headBranchName"
              placeholder="Ex. develop"
              required
            />
          </mat-form-field>
          <button
            #submit
            mat-raised-button
            color="primary"
            [class.spinner]="loadingLoad"
            [disabled]="!githubForm.valid"
            (click)="compareBranches()"
          >
            Compare
          </button>
        </form>
      </mat-card>
    </div>
    <div style="margin: 30px 0 0 20px; width: 90%" *ngIf="isShownLoad">
      <mat-grid-list cols="2" rowHeight="180px">
        <mat-grid-tile *ngFor="let repository of repositories">
          <mat-card>
            <mat-card-title>{{ repository.repository_name }}</mat-card-title>
            <mat-card-subtitle>
              <mat-grid-list cols="4" rowHeight="30px">
                <mat-grid-tile>
                  Base branch exist :
                  <mat-icon
                    [ngClass]="repository.hasBaseBranch ? 'green' : 'red'"
                    >{{
                      repository.hasBaseBranch ? 'check' : 'clear'
                    }}</mat-icon
                  >
                </mat-grid-tile>
                <mat-grid-tile>
                  Head branch exist :
                  <mat-icon
                    [ngClass]="repository.hasHeadBranch ? 'green' : 'red'"
                    >{{
                      repository.hasHeadBranch ? 'check' : 'clear'
                    }}</mat-icon
                  >
                </mat-grid-tile>
                <mat-grid-tile [colspan]="2">
                  Last change : {{ repository.repository_last_change }}
                </mat-grid-tile>
              </mat-grid-list>
            </mat-card-subtitle>
            <mat-card-content
              *ngIf="repository.hasBaseBranch && repository.hasHeadBranch"
            >
              <mat-grid-list cols="4" rowHeight="30px">
                <mat-grid-tile
                  >Status : {{ repository.compare.status }}</mat-grid-tile
                >
                <mat-grid-tile class="red"
                  >Different files
                  {{ repository.compare.files_diff }}</mat-grid-tile
                >
                <mat-grid-tile
                  >Ahead by
                  {{ repository.compare.ahead_by }} commits</mat-grid-tile
                >
                <mat-grid-tile
                  >Behind by
                  {{ repository.compare.behind_by }} commits</mat-grid-tile
                >
              </mat-grid-list>
            </mat-card-content>
            <mat-card-actions
              *ngIf="repository.hasBaseBranch && repository.hasHeadBranch"
            >
              <a
                mat-raised-button
                [href]="repository.repository_url"
                target="_blank"
                >Repository</a
              >
              <a
                mat-raised-button
                [href]="repository.compare.compare_url"
                target="_blank"
                >Compare</a
              >
            </mat-card-actions>
          </mat-card>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </div>
</section>
